import { render, staticRenderFns } from "./TermsandCondition.vue?vue&type=template&id=e05b71c0&scoped=true"
import script from "./TermsandCondition.vue?vue&type=script&lang=js"
export * from "./TermsandCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsandCondition.vue?vue&type=style&index=0&id=e05b71c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05b71c0",
  null
  
)

export default component.exports